// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#nutrition,table{width:100%}table{border:1px solid #000;border-collapse:collapse;border-spacing:.5em}td,th{border-bottom:1px solid #000;padding:.5em;font-family:Montserrat,Arial,sans-serif}.rule1{border-bottom:5px solid #000}.rule2{border-bottom:8px solid #000}.text-left{text-align:left}.text-right{text-align:right}.indent{padding-left:1em}.large{font-size:1.25em;font-weight:700}", ""]);
// Exports
module.exports = exports;
